import { z } from "zod";

export const positiveIntegerSchema = z.number().int().positive();
export const stringArraySchema = z.array(z.string());

export const SHEET_FILTER_KEY = "sheet:key";

export type TSheetDataFilterKey = `sheet:data:${string}`;
export type TSheetFilter = {
  data: Record<string, string>;
};
export type TSheetFilters = Record<string, TSheetFilter>;

export const isSheetDataFilterKey = (
  value: string,
): value is TSheetDataFilterKey => /^sheet:data:[^:]+$/u.test(value);

export const getSheetDataFilterKey = <TKey extends string>(
  key: TKey,
): `sheet:data:${TKey}` => `sheet:data:${key}`;

export const getSheetDataKey = <TKey extends string>(
  filter: `sheet:data:${TKey}`,
): TKey => filter.slice("sheet:data:".length) as TKey;

export const sheetFiltersSchema: z.ZodType<TSheetFilters> = z.record(
  z.string().min(1),
  z.object({
    data: z.record(z.string().min(1), z.string().min(1)),
  }),
);

export type TTabFilterKey = `tabs:${string}:key`;
export type TTabFilters = Partial<Record<TTabFilterKey, string>>;

export const isTabFilterKey = (value: string): value is TTabFilterKey => (
  /^tabs:[^:]+:key$/u.test(value)
);

export const getTabFilterKey = <TId extends string>(
  id: TId,
): `tabs:${TId}:key` => `tabs:${id}:key`;

const tabFilterKeySchema = z.custom<TTabFilterKey>((value) => (
  typeof value === "string" && isTabFilterKey(value)
));

export const tabFiltersSchema: z.ZodType<TTabFilters> = z.record(
  tabFilterKeySchema,
  z.string().min(1),
);

export const articleFiltersSchema = z.object({
  "articles:page": positiveIntegerSchema,
  "articles:categories": stringArraySchema,
});

export const filtersSchema = z.object({
  articles: articleFiltersSchema,
  sheets: sheetFiltersSchema,
  tabs: tabFiltersSchema,
});

export type TArticleFilters = z.infer<typeof articleFiltersSchema>;
export type TFilters = z.infer<typeof filtersSchema>;
